import '@babel/polyfill';
import format from 'date-fns/format';
import getUrlParam from 'qj/getUrlParam';
import React, { Component } from 'react';
import './App.css';
import Card from './components/card';
import CardHeader from './components/cardheader';
import ClosingTimes from './components/closingTimes';
import Filter from './components/filter';
import Modal from './components/modal';
import VesselHeader from './components/vesselheader';
import VesselInfo from './components/vesselInfo';
import VisitList from './components/visitlist';
import VisitListOverview from './components/visitListOverview';
import VisitListOverviewSimple from './components/visitListOverviewSimple';
import VoyageList from './components/voyagelist';
import VoyageMap from './components/voyageMap';
import { api, isEmpty, compareVoyagesByReferenceNumber } from './utils';
import { VoyageDataDTO } from './voyageDTO';
import MockMenu from './components/mockMenu';
import { Default, Mobile } from './responsive';

// if (!String.prototype.startsWith) {
//   String.prototype.startsWith = function(searchString, position) {
//     position = position || 0;
//     return this.indexOf(searchString, position) === position;
//   };
// }
class App extends Component {
  constructor(props) {
    super(props);

    this.hoistState = this.hoistState.bind(this);

    this.state = {
      portCode: props.portCode,
      vesselRef: props.vesselRef,
      voyageRef: props.voyageRef,
      ports: props.ports ? props.ports : [],
      vessels: props.vessels ? props.vessels : [],
      voyages: props.voyages ? props.voyages : [],
      routes: props.routes ? props.routes : [],
      lastFilter: undefined, // last used filter, should override view
      showModal: false,
      showModalMap: false,
      vesselInfoRef: null,
      mapLineType: '',
      showingGMT: false,
      showFilters: false,
      lang: props.lang || 'en'
    };

    this.handleFilters = this.handleFilters.bind(this);
    this.renderVoyages = this.renderVoyages.bind(this);
    this.renderVesselVoyages = this.renderVesselVoyages.bind(this);
    this.renderVesselVoyagesList = this.renderVesselVoyagesList.bind(this);
    this.toggleFilterUI = this.toggleFilterUI.bind(this);
    this.renderFilterView = this.renderFilterView.bind(this);
    this.renderToggleUIButton = this.renderToggleUIButton.bind(this);
  }

  componentWillMount() {
    api.getVoyages('', '', '', '', '').then(data => {
      if (data.rangedVoyages) {
        this.setState({ voyageData: new VoyageDataDTO(data.rangedVoyages) });
      } else if (data.currentVoyages && data.outstandingVoyages) {
        let allVoyages = data.currentVoyages;
        allVoyages = allVoyages.concat(data.outstandingVoyages);
        const voyageDataDTO = new VoyageDataDTO(allVoyages);
        this.setState({
          initialCurrentRaw: data.currentVoyages,
          initialRaw: allVoyages,
          voyageData: voyageDataDTO,
          ports: voyageDataDTO.getPorts(),
          vessels: voyageDataDTO.getVessels(),
          voyages: voyageDataDTO.getVoyages(),
          routes: voyageDataDTO.getRoutes()
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  onModalClose() {
    this.setState({ showModal: false });
  }

  onModalMapClose() {
    this.setState({ showModalMap: false });
  }

  onMapClick(mapLineType) {
    this.setState({ showModalMap: true, mapLineType });
  }

  onInfoClick = vesselInfoRef => {
    this.setState({ vesselInfoRef, showModal: true });
  };

  onPressButton(showingGMT) {
    this.setState({ showingGMT });
  }

  renderVoyagesOverviewSimple() {
    const voyageData = new VoyageDataDTO(this.state.initialCurrentRaw);
    return (
      <Card className="simple">
        <div className="cardheader boxhead">{this.state.lang === 'is' ? 'Siglingaráætlun' : 'Voyage schedule'}</div>
        <VisitListOverviewSimple
          voyages={voyageData.getVoyages()}
          showingGMT={this.state.showingGMT}
          lang={this.state.lang}
        />
      </Card>
    );
  }

  findNextVoyage(voyage, allVoyagesUnsorted) {
    let nextVoyage = null;
    const allVoyagesForVessel = []; //for testing / console log

    const allVoyages = allVoyagesUnsorted.sort(compareVoyagesByReferenceNumber);

    for (let i = allVoyages.length - 1; i >= 0; i--) {
      const vessel = allVoyages[i].vessel;
      const voyageRef = allVoyages[i].reference;
      const status = allVoyages[i].status;

      if (vessel.reference === voyage.vessel.reference) {
        allVoyagesForVessel.unshift(allVoyages[i].reference);

        if (nextVoyage === null && voyageRef !== voyage.reference) {
          nextVoyage = allVoyages[i];
        }

        if (
          nextVoyage !== null &&
          voyageRef < nextVoyage.reference &&
          voyageRef > voyage.reference &&
          status === 'OUTSTANDING'
        ) {
          nextVoyage = allVoyages[i];
        }
      }
    }

    return nextVoyage;
  }

  addNextVoyage(voyageData, allVoyages) {
    const voyages = voyageData.getVoyages();

    for (let i = 0; i < voyages.length; i++) {
      const nextVoyage = this.findNextVoyage(voyages[i], allVoyages);
      voyages[i].nextVoyage = nextVoyage;
    }

    voyageData.voyages = voyages;

    return voyageData;
  }

  renderVoyagesOverview() {
    const voyageData = new VoyageDataDTO(this.state.initialCurrentRaw);
    return (
      <Card className="nobackground">
        <VisitListOverview
          voyages={voyageData.getVoyages()}
          showingGMT={this.state.showingGMT}
          showClosingTimes={this.props.showClosingTimes}
          lang={this.state.lang}
        />
      </Card>
    );
  }

  /* Renders list of vessels along with current voyage visits   */
  renderVoyages() {
    let voyageData = new VoyageDataDTO(this.state.initialCurrentRaw);
    voyageData = this.addNextVoyage(voyageData, this.state.voyages);

    return (
      <Card className="nobackground">
        <VisitListOverview
          voyages={voyageData.getVoyages()}
          showingGMT={this.state.showingGMT}
          showClosingTimes={this.props.showClosingTimes}
          lang={this.state.lang}
        />
      </Card>
    );
  }

  /* Renders list of vessels along with current voyage   */
  renderVesselVoyagesList() {
    const state = this.state;
    const voyageData = state.voyageData;
    const portCode = state.portCode;
    const vessels = voyageData.getVessels();
    let portName = null;

    let groupedVoyages = vessels.map(vessel => {
      return voyageData.getVoyagesByVesselReference(vessel.reference);
    });

    if (portCode) {
      groupedVoyages = voyageData.getVoyagesByPortCodeGrouped(portCode);
    }

    return groupedVoyages.map((group, index) => {
      const key = `v_${index}`;
      const vessel = group[0].getVessel();
      const allVisits = this.getVisitsTransposed(group);

      return (
        <Card key={key} className="nobackground">
          <CardHeader
            primaryTitle={this.state.lang === 'is' ? "Áætlun" : "Estimated Schedule"}
            primarySubTitle={'Local time: '}
            primarySubTitleAddClock={true}
            secondaryTitle={vessel.name}
            secondarySubTitle={vessel.reference}
            onOpenMap={this.onMapClick.bind(this)}
            description={group[0].getLineDescription()}
            onPressButton={this.onPressButton.bind(this)}
            showingGMT={this.state.showingGMT}
            lang={this.state.lang}
          >
            <VesselHeader
              vessel={vessel}
              onOpenInfo={() => {
                this.onInfoClick(vessel.reference);
              }}
              lang={this.state.lang}
            />
          </CardHeader>
          {<VoyageList visits={allVisits} itemClassModifier="auto" portName={portName} />}
        </Card>
      );
    });
  }

  getVisitsTransposed(voyages) {
    const allVisits = voyages.map(voyage => {
      return voyage.getVoyageVisitsTransposed();
    });
    // console.log('allVisits', allVisits);

    /*
      The headache:
      - 1. The data does not contain all visitNo for all voyages. Ex: [2, 4, 5] - (Skálafell)
      - 2. The data contains extra visitNo like "3.5" for some voyages. Ex: [1, 3, 3.5, 5] - (Skaftafell)
      - 3. The data is sometimes inconsistent, visitNo "2" can be "Isafjordur" on one voyage and "Saudar­krokur" on the next - (Skaftafell)
    */

   let visitsMatrix = {};
   let headers = [''];

    // generate placeholders
    for (let a = 0; a < allVisits.length; a++) {
      headers.push(allVisits[a][0].voyage);
      for (let b = 0; b < allVisits[a].length; b++) {
        let visitNo = allVisits[a][b].visitNo;
        if ( visitsMatrix[visitNo] && visitsMatrix[visitNo][0] !== allVisits[a][b].port ) {
          // hax for headache 3
          visitsMatrix[`${visitNo}.extra`] = [allVisits[a][b].port];
          allVisits[a][b].visitNo = `${allVisits[a][b].visitNo}.extra`;
        }
        else {
          visitsMatrix[visitNo] = [allVisits[a][b].port];
        }

      }
    }

    const visitNos = Object.keys(visitsMatrix).sort();

    // transpose data
    for (let i = 0; i < allVisits.length; i++) {
      const thisVisit = allVisits[i];

      let count = 0;
      for (let j = 0; j < visitNos.length; j++) {
        const visitNosJ = visitNos[j];
        const visit = thisVisit[count];

        if ( visit && visit.visitNo === visitNosJ ) {
          visitsMatrix[visitNosJ].push(visit.etd);
          count++;
        }
        else {
          visitsMatrix[visitNosJ].push('');
        }
      }
    }

    // generate table data
    const allVisits2 = [];
    for (let v = 0; v < visitNos.length; v++) {
      const visits = visitsMatrix[visitNos[v]];
      allVisits2.push({ 'visits': visits, 'headers': headers });
    }

    return allVisits2;
  }

  /* Renders list of voyages for a selected vessel   */
  renderVesselVoyages() {
    const voyageData = this.state.voyageData;
    let voyages = voyageData.getVoyages();

    if (isEmpty(voyages)) {
      return null;
    }

    const vesselRef = this.state.vesselRef;
    const voyageRef = this.state.voyageRef;
    const routeRef = this.state.routeRef;
    let vessel = voyages[0].getVessel();
    let portName = null;

    voyages.forEach(voyage => {
      if (portName === null) {
        portName = voyage.getPortName(this.state.portCode);
      }
    });

    if (routeRef) {
      voyages = voyageData.getVoyagesByRoute(routeRef);
      vessel = [
        ...new Set( // shorthand to create an array with unique items
          voyages.map(voyage => {
            return voyage.getVessel().name;
          })
        )
      ].join(', ');
    }

    if (vesselRef) {
      voyages = voyageData.getVoyagesByVesselReference(vesselRef);
      vessel = voyageData.getVesselByReference(vesselRef).name;
    }

    if (voyageRef) {
      voyages = voyageData.getVoyageByReference(voyageRef);
      vessel = voyages[0].getVessel().name;
    }

    const allVisits = this.getVisitsTransposed(voyages);

    const lastChanged = voyages.map((voyage, index) => voyage.getLastChanged());
    lastChanged.unshift('Updated');
    allVisits.push({ visits: lastChanged, headers: allVisits[0].headers, lastChanged: true });

    let updated = 'Updated: ';
    if (voyages.length === 1 && voyages[0].lastChanged !== null) {
      updated += format(voyages[0].lastChanged, 'DD.MM.YY');
    } else {
      updated += 'n/a';
    }

    return (
      <Card className="nobackground">
        <CardHeader
          primaryTitle={this.state.lang === 'is' ? "Áætlun" : "Estimated Schedule"}
          primarySubTitle={updated}
          secondaryTitle={vessel}
          secondarySubTitle={''}
          onOpenMap={this.onMapClick.bind(this)}
          description={voyages[0].getLineDescription()}
          onPressButton={this.onPressButton.bind(this)}
          showingGMT={this.state.showingGMT}
          lang={this.state.lang}
        >
          <VesselHeader
            vessel={vessel}
            onOpenInfo={() => {
              this.onInfoClick(vessel.reference);
            }}
            lang={this.state.lang}
          />
        </CardHeader>
        {<VoyageList visits={allVisits} itemClassModifier="auto" portName={portName} lang={this.state.lang} />}
      </Card>
    );
  }

  hoistState(stateObject) {
    if (stateObject.clear) {
      const voyageDataDTO = new VoyageDataDTO(this.state.initialRaw);
      stateObject.voyageData = voyageDataDTO;
      stateObject.ports = voyageDataDTO.getPorts();
      stateObject.vessels = voyageDataDTO.getVessels();
      stateObject.voyages = voyageDataDTO.getVoyages();
      stateObject.routes = voyageDataDTO.getRoutes();
    }
    this.setState(stateObject);
  }

  filterByRouteRef(routeRef, voyageData) {
    const voyages = voyageData.getVoyagesByRoute(routeRef);
    if (isEmpty(voyages)) {
      return null;
    }

    return {
      voyages: voyages,
      vessels: voyageData.getVesselsByRoute(routeRef),
      ports: voyageData.getPortsByRoute(routeRef)
    };
  }

  filterByVesselRef(vesselRef, voyageData) {
    const voyages = voyageData.getVoyagesByVesselReference(vesselRef);
    if (isEmpty(voyages)) {
      return null;
    }

    return {
      voyages: voyages,
      ports: voyageData.getPortsByVesselReference(vesselRef)
    };
  }

  filterByVoyageRef(voyageRef, voyageData) {
    let voyages = voyageData.getVoyageByReference(voyageRef);
    if (isEmpty(voyages)) {
      return null;
    }

    let vessel = voyages[0].getVessel();
    return {
      vessels: [vessel],
      ports: voyageData.getPortsByVesselReference(vessel.reference)
    };
  }

  filterByPortCode(portCode, voyageData) {
    const groupedVoyages = voyageData.getVoyagesByPortCodeGrouped(portCode);
    let result = {
      vessles: groupedVoyages.map(group => group[0].getVessel()),
      groupedVoyages: groupedVoyages
    };

    if (!this.state.vesselRef) {
      result['voyages'] = voyageData.getVoyagesByPortCode(portCode);
    }

    return result;
  }

  handleFilters() {
    const comp = this;
    const state = comp.state;
    let filterObject = {
      ports: state.ports,
      vessels: state.vessels,
      voyages: state.voyages,
      routes: state.routes,
      renderFunction: comp.renderVoyages
    };

    if (state.rangedData) {
      filterObject['renderFunction'] = comp.renderVesselVoyagesList;
    }

    // if routeRef set use as first filter
    // if vesselRef set use as second filter
    // if portCode set use as third filter
    // if voyage set use as fourth filter

    if (state.routeRef) {
      Object.assign(filterObject, comp.filterByRouteRef(state.routeRef, state.voyageData));
      if (!state.lastFilter) {
        Object.assign(filterObject, {
          renderFunction: comp.renderVesselVoyages
        });
      }
    } else if (state.vesselRef) {
      Object.assign(filterObject, comp.filterByVesselRef(state.vesselRef, state.voyageData));
      if (!state.lastFilter) {
        Object.assign(filterObject, {
          renderFunction: comp.renderVesselVoyages
        });
      }
    } else if (state.portCode) {
      Object.assign(filterObject, comp.filterByPortCode(state.portCode, state.voyageData));
      if (!state.lastFilter) {
        Object.assign(filterObject, {
          renderFunction: comp.renderVesselVoyagesList
        });
      }
    } else if (state.voyageRef) {
      Object.assign(filterObject, comp.filterByVoyageRef(state.voyageRef, state.voyageData));
      if (!state.lastFilter) {
        Object.assign(filterObject, {
          renderFunction: comp.renderVesselVoyages
        });
      }
    }

    // if set state.lastFilter determines renderFunction
    // when undefined renderFunction is determined by filter order
    switch (state.lastFilter) {
      case 'portCode':
        filterObject['renderFunction'] = comp.renderVesselVoyagesList;
        break;
      case 'vesselRef':
        filterObject['renderFunction'] = comp.renderVesselVoyages;
        break;
      case 'voyageRef':
        filterObject['renderFunction'] = comp.renderVesselVoyages;
        break;
      case 'routeRef':
        filterObject['renderFunction'] = comp.renderVesselVoyages;
        break;
      default:
        break;
    }

    return filterObject;
  }

  toggleFilterUI() {
    this.setState({ showFilters: !this.state.showFilters });
  }

  renderFilterView() {
    const comp = this;
    const state = comp.state;
    const filterObject = comp.handleFilters();
    return (
      <div>
        <header className="voyager--header">
          {state.voyageData && (
            <Filter
              hoistState={comp.hoistState}
              voyageData={state.voyageData}
              ports={filterObject.ports}
              vessels={filterObject.vessels}
              voyages={filterObject.voyages}
              routes={filterObject.routes}
              lang={this.state.lang}
            />
          )}
        </header>

        <div className="cardlist">{filterObject.renderFunction()}</div>

        <Modal show={this.state.showModal} onClose={this.onModalClose.bind(this)}>
          <VesselInfo vesselRef={this.state.vesselInfoRef} onClose={this.onModalClose.bind(this)} lang={this.state.lang} />
        </Modal>
        <Modal show={this.state.showModalMap} onClose={this.onModalMapClose.bind(this)}>
          <VoyageMap lineType={this.state.mapLineType} />
        </Modal>
      </div>
    );
  }

  renderToggleUIButton() {
    const hideFilterText = this.state.lang === 'is' ? 'Fela síu' : 'Hide filters';
    const showFilterText = this.state.lang === 'is' ? 'Sýna síu' : 'Show filters';
    return (
      <div className="toggleUI__wrapper">
        <div className="toggleUI__wrapper__inner">
          <button onClick={this.toggleFilterUI} className="toggleUI">
            {this.state.showFilters ? hideFilterText: showFilterText}
          </button>
        </div>
      </div>
    );
  }

  render() {
    const showOverviewSimple = this.props.showOverviewSimple;

    if (showOverviewSimple) {
      return this.renderVoyagesOverviewSimple();
    }

    return (
      <React.Fragment>
        <Default>
          <div className="App">
            {this.props.showFilters ? this.renderFilterView() : this.renderVoyagesOverview()}
          </div>
        </Default>
        <Mobile>
          <div className="App mobile">
            {this.props.showFilters ? this.renderFilterView() : this.renderVoyagesOverview()}
          </div>
        </Mobile>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js